import { IUpdatedByAtAndCreatedByAt } from '../types';
import { uuid } from '../util/uuid';
import { createFieldDataModel, IField, KpiTemplateSectionType } from './field2.data-model';
import { KpiSection } from './company-financials.data-model';
import { BaseTemplate, BaseTemplateSection } from '../schemas/kpi-template.schema';

export interface IKpiTemplateSectionMeta {
  sortOrder?: number;
  section: KpiSection;
}

export interface ITextualKpiTemplateSectionMeta extends IKpiTemplateSectionMeta {
  kpiConfig: IField<unknown>;
  // section should be hardcoded to 'actual' for now
}

export interface IKPITableDataModel extends IKpiTemplateSectionMeta {
  description: string;
  displayName: string;
  metrics: IField<unknown>[];
}

export function isKpiTableDataModel(
  meta: IField<unknown> | IKPITableDataModel | ITextualKpiTemplateSectionMeta
): meta is IKPITableDataModel {
  return 'metrics' in meta && 'section' in meta;
}

export interface IKPITemplateSectionDataModel extends Omit<BaseTemplateSection, 'meta'> {
  templateId: number;
  // FIXME: MAGGIE-4576
  type?: KpiTemplateSectionType | string;
  // FIXME: https://foresightdata.atlassian.net/browse/MAGGIE-5684
  meta: IField<unknown> | IKPITableDataModel | ITextualKpiTemplateSectionMeta;
}

export interface IKPITemplate extends Omit<BaseTemplate, 'meta'>, IUpdatedByAtAndCreatedByAt {
  uuid: string;
  id: number;
  meta?: Record<string, unknown> | null;
  sections?: IKPITemplateSectionDataModel[] | null | undefined;
}

export function createKPITemplateDataModel(overrides: Partial<IKPITemplate> = {}): IKPITemplate {
  return {
    uuid: uuid(),
    id: 1,
    isManagedService: false,
    name: '',
    sections: [],
    version: 1,
    ...overrides,
  };
}

export function createKPITemplateSectionDataModel(
  overrides: Partial<IKPITemplateSectionDataModel> = {}
): IKPITemplateSectionDataModel {
  return {
    meta: createFieldDataModel({}),
    name: '',
    type: KpiTemplateSectionType.field,
    templateId: 0,
    ...overrides,
  };
}
